module.exports = __webpack_public_path__ + "img/sponsor@2x.44ade53e.png";